var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHaveLicence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 6.7002C0.5 8.29149 1.13214 9.81762 2.25736 10.9428C3.38258 12.0681 4.9087 12.7002 6.5 12.7002C8.0913 12.7002 9.61742 12.0681 10.7426 10.9428C11.8679 9.81762 12.5 8.29149 12.5 6.7002C12.5 5.1089 11.8679 3.58277 10.7426 2.45755C9.61742 1.33234 8.0913 0.700195 6.5 0.700195C4.9087 0.700195 3.38258 1.33234 2.25736 2.45755C1.13214 3.58277 0.5 5.1089 0.5 6.7002ZM9.62 5.6202C9.70666 5.50465 9.74873 5.36173 9.73849 5.21766C9.72825 5.0736 9.66639 4.93806 9.56426 4.83593C9.46214 4.7338 9.3266 4.67194 9.18253 4.6617C9.03847 4.65147 8.89554 4.69354 8.78 4.7802L5.9 7.6602L4.52 6.2802C4.40446 6.19354 4.26153 6.15147 4.11747 6.16171C3.9734 6.17194 3.83786 6.2338 3.73574 6.33593C3.63361 6.43806 3.57175 6.5736 3.56151 6.71766C3.55127 6.86173 3.59334 7.00465 3.68 7.1202L5.48 8.9202C5.72 9.1602 6.08 9.1602 6.32 8.9202L9.62 5.6202Z",
    fill: "#032339"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaveLicence);
export default __webpack_public_path__ + "static/media/HaveLicence.e6afbdfbf1c4fb5a0d4c93a5e6426ac3.svg";
export { ForwardRef as ReactComponent };